import React from 'react';
import ClockWidget from './widgets/ClockWidget';
import TechFeedWidget from './widgets/TechFeedWidget';
import SportsFeedWidget from './widgets/SportsFeedWidget';

const WidgetsSection: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="inline-flex items-center gap-2 rounded-full border border-slate-700/70 bg-slate-900/60 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-300">
        Live desk
        <span className="h-1 w-1 rounded-full bg-emerald-400" />
      </div>
      <p className="max-w-2xl text-sm text-slate-300">
        A small control panel with live time and curated links I actually use to keep up with the technology and sports
        worlds I build for.
      </p>
      <div className="grid gap-4 md:grid-cols-3">
        <ClockWidget />
        <TechFeedWidget />
        <SportsFeedWidget />
      </div>
    </div>
  );
};

export default WidgetsSection;

